package com.hyperether.goodjob.scenes.addNew.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.DropdownMenu
import androidx.compose.material.Text
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.toSize
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.is4K
import com.hyperether.goodjob.scenes.components.TrailingDropdownIconButton
import com.hyperether.goodjob.scenes.components.noRippleClickable
import com.hyperether.goodjob.theme.InputBorderColor
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp


@Composable
fun AddNewJobDropdownInput(
    text: MutableState<String>,
    label: String? = null,
    placeholder: String,
    dropdownItems: Map<String, String>,
    modifier: Modifier = Modifier,
    onValueChange: (String) -> Unit = {}
) {
    var expanded by remember { mutableStateOf(false) }
    var textFieldSize = remember { mutableStateOf(Size.Zero) }

    Box(
        modifier = if (!getPlatformChecker().isMobile() && is4K()) modifier
            .fillMaxWidth()
            .height(56.toScaleDp())
            .noRippleClickable {
                expanded = !expanded
            } else modifier
            .fillMaxWidth()
            .noRippleClickable {
                expanded = !expanded
            }
    ) {
        OutlinedTextField(
            value = text.value,
            onValueChange = {
                text.value = it
            },
            label = label?.let {
                {
                    Text(label, fontSize = 14.toScaleSp(), color = TextColor)
                }
            },
            placeholder = { Text(placeholder, fontSize = 14.toScaleSp(), color = Color.LightGray) },
            singleLine = true,
            modifier = Modifier
                .fillMaxSize()
                .onGloballyPositioned { coordinates ->
                    textFieldSize.value = coordinates.size.toSize()
                },
            trailingIcon = {
                TrailingDropdownIconButton(onClick = { expanded = !expanded })
            },
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            colors = OutlinedTextFieldDefaults.colors(
                disabledBorderColor = InputBorderColor,
                unfocusedBorderColor = InputBorderColor,
                disabledTextColor = TextColor
            ),
            enabled = false
        )

        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false },
            modifier = Modifier.width(with(LocalDensity.current) { textFieldSize.value.width.toDp() })
        ) {
            dropdownItems.forEach { item ->
                DropdownMenuItem(
                    modifier = Modifier.height(45.toScaleDp())
                        .pointerHoverIcon(PointerIcon.Hand),
                    onClick = {
                        text.value = item.key
                        expanded = false
                        onValueChange(item.key)
                    },
                    text = {
                        DisableSelection {
                            Text(
                                item.key,
                                maxLines = 1,
                                fontSize = 14.toScaleSp(),
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                )
            }
        }
    }
}

@Composable
fun ReadOnlyTimePickerField(
    label: String,
    value: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = if (!getPlatformChecker().isMobile() && is4K()) modifier
            .fillMaxWidth()
            .height(56.toScaleDp())
            .noRippleClickable {
                onClick()
            } else modifier
            .fillMaxWidth()
            .noRippleClickable {
                onClick()
            }
    ) {
        OutlinedTextField(
            value = value,
            onValueChange = {},
            label = { Text(label, fontSize = 14.toScaleSp(), color = TextColor) },
            placeholder = { Text(label, fontSize = 14.toScaleSp(), color = Color.LightGray) },
            enabled = false,
            singleLine = true,
            modifier = Modifier.fillMaxSize(),
            textStyle = TextStyle(
                color = Color.DarkGray,
                fontSize = 14.toScaleSp(),
                lineHeight = 16.toScaleSp(),
                textAlign = TextAlign.Start
            ),
            colors = OutlinedTextFieldDefaults.colors(
                disabledBorderColor = InputBorderColor,
                disabledTextColor = TextColor,
                disabledLabelColor = TextColor
            )
        )
    }
}